import { render, staticRenderFns } from "./GenericNotificationApiView.vue?vue&type=template&id=d4e286c6&"
import script from "./GenericNotificationApiView.vue?vue&type=script&lang=ts&"
export * from "./GenericNotificationApiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports